import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import base from "./base";
import cart from "./cart";
import user from "./user";
import config from "./config";
import notify from "./notify";
import products from "./products";
import categories from "./categories";

export default new Vuex.Store({
	strict: true,
	modules: {
		base,
		cart,
		user,
		config,
		notify,
		products,
		categories
	}
});
